module.exports = __webpack_public_path__ + "ic-history-black-24-px-copy-4-65479dc888586efb01715a007bab53a1.svg";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/ic-history-black-24-px-copy-4.svg
// module id = dFE1
// module chunks = client